module.exports = __webpack_public_path__ + "media/images/img-drop-07340b8500aef6fe42f84d8d93befc37.svg";